module.exports = __webpack_public_path__ + "media/images/countrysquared/bn-f89e5274a3c7fdc140d4f6e9ed488f3e.svg";